import { useState, useEffect } from "react";
import ReactDom from "react-dom";
import Input from "./Input";
import Button from "../Button";
import Logo from "../Logo/Logo";
import { MdOutlineCancel } from "react-icons/md";
import ButtonToAdd from "../ButtonToAdd";

// import {}

function CreateForm(props) {
  const { onEscPress } = props;
  useEffect(() => {
    function closePopUp(event) {
      if (event.code === "Escape") {
        onEscPress();
      }
    }
    window.addEventListener("keyup", closePopUp);
    return () => {
      return window.removeEventListener("keyup", closePopUp);
    };
  }, [onEscPress]);
  const [extraField, setExtraField] = useState(1);
  const onCancelHandler = (e) => {
    e.preventDefault();

    props.onCancelHandler();
    props.onChangeDropShadowHandler();
  };
  const onCrossHandler = () => {
    props.onChangeDropShadowHandler();
  };
  const onAddExtraField = (e) => {
    e.preventDefault();

    setExtraField((prevState) => prevState + 1);
  };
  const onDeleteMultipleInputField = (index) => {
    props.onDeleteMultiFieldHandler(index);
    setExtraField((prevState) => prevState - 1);
  };
  const repeatedItemList = () => {
    let listItem = [];
    let list = "";
    for (let i = 1; i <= extraField; i++) {
      list = (
        <div
          key={i}
          className={`relative ${
            extraField >= 2 && "border-b-[1px]"
          } border-bgwhitegrey pb-2 mb-3`}
        >
          {i > 1 && ( //to add cancel button if add more item is more than 1
            <div
              className="absolute right-[4%] text-xl cursor-pointer z-40"
              onClick={() => onDeleteMultipleInputField(i - 1)}
            >
              {" "}
              <MdOutlineCancel />
            </div>
          )}
          {props.NewFormOptions.length > 0 &&
            props.NewFormOptions.map((item) => {
              return (
                <Input
                  key={item.labelName}
                  valueLabel={item.valueLabel}
                  onInputChangeHandler={props.onDuplicateInputChangeHandler}
                  type={item.type}
                  Name={item.labelName}
                  value={props.generalDuplicateFormData[item.valueLabel][i - 1]}
                  index={i - 1}
                  placeholder={item.placeholder}
                  isRequired={item.isRequired}
                  options={item.options ? item.options : ""}
                  CustomInputStyle={item.CustomInputStyle}
                  labelStyle={item.labelStyle}
                  errorMsg={props.ErrorData[item.valueLabel]}
                />
              );
            })}
        </div>
      );
      listItem.push(list);
    }
    return listItem;
  };

  const form = (
    <div
      className={`py-4 md:py-4 rounded-lg   ${
        props.FormStyle ? `${props.FormStyle}` : "shadow-overlayshadow"
      } px-4 bg-bgwhite md:w-[40%] fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] z-30  `}
    >
      {props.CreateName !== "Login" && (
        <div
          onClick={onCrossHandler}
          className="absolute top-[3%] right-[5%] text-2xl cursor-pointer text-btnbgcolor"
        >
          <MdOutlineCancel />
        </div>
      )}

      {props.isLogo && <Logo />}

      <div className="mb-6">
        <h1 className="text-btnbgcolor mb-1 text-sm md:text-lg font-semibold text-center">
          {props.CreateName.toUpperCase()}
        </h1>
        <p className="mb-3 text-xs lg:text-lg text-center">
          Enter your credentials to {props.CreateName.toLowerCase()}
        </p>
      </div>
      <form
        // onSubmit={
        //   props.createOrUpdate === "Create"
        //     ? props.setListHandler
        //     : props.onEditSubmit
        // }
      >
        {props.FormOptions.map((item) => {
          if (
            (item.type !== "password" ||
              props.CreateName === "Login" ||
              props.createOrUpdate === "Create") &&
            (item.repeatType !== true ||
              ((props.OptionNameList === "Product" ||
                props.OptionNameList === "Cartoon Stock") &&
                props.createOrUpdate === "Update"))
          ) {
            return (
              <Input
                key={item.labelName}
                valueLabel={item.valueLabel}
                onInputChangeHandler={props.onInputChangeHandler}
                type={item.type}
                Name={item.labelName}
                value={props.inputFormData[item.valueLabel]}
                placeholder={item.placeholder}
                isRequired={item.isRequired}
                options={item.options ? item.options : ""}
                CustomInputStyle={item.CustomInputStyle}
                errorMsg={props.ErrorData[item.valueLabel]}
              />
            );
          } else {
            return null;
          }
        })}

        {props.NewFormOptions?.length > 0 &&
          props.createOrUpdate === "Create" &&
          repeatedItemList()}

        {/* seprate button to add another module */}
        {props.extraAddBtn && props.createOrUpdate !== "Update" && (
          <div className="inline-block">
            <ButtonToAdd
              text={props.extraButtonText}
              onClick={onAddExtraField}
            />
          </div>
        )}

        <div
          className={`flex justify-between mt-4 ${
            (props.OptionNameList === "Product" ||
              props.OptionNameList === "Cartoon Stock") &&
            "w-[90%]"
          }`}
        >
          {!props.isNotCancelBtn && (
            <Button
              onClickHandler={onCancelHandler}
              btnStyle="bg-bgwhite border-[1px] border-btnbgcolorlight mr-2 "
              btnName="Cancel"
            />
          )}
          <Button
            type="submit"
            btnStyle={`bg-btnbgcolor text-bgwhite ${
              props.isNotCancelBtn ? "w-full" : ""
            }`}
            btnName={props.createOrUpdate}
          />
        </div>
        {props.children}
      </form>
    </div>
  );
  return ReactDom.createPortal(form, document.querySelector("#over-lay"));
}

export default CreateForm;
